import React  from 'react';
import { LineChart } from '../chart';
import './styles.scss';

const UnitStats = ({ unitData }) => {
    const showGraph = (typeCode, chainGroupCode) => {
        
        if (chainGroupCode === '6') {
            return false;
        }
        
        switch (typeCode) {
            case '105':
            case '295':
            case '109':
            case '500':
            case '501':
            case '502':
            case '503':
            case '504':
            case '505':
                return false;
            default: 
                return true;
        }
    };

    return (
        <section className="unit-stats">
            <div className="unit-stats__wrapper">
                <div className="unit-stats__async">
                    {unitData &&
                        <>
                            {unitData.TypeGroupName === 'Foodservice' && 
                                <div className="unit-stats__content">
                                    {unitData.TurnoverMeal*1 > 0 && 
                                        <div className="unit-stats__col unit-stats__col--wide"> 
                                            <h2 className="unit-stats__heading">Årsomsättning måltider <span className="unit-stats__heading-unit">(antal/dag)</span></h2>
                                            <p className="unit-stats__stat-value">{(unitData.TurnoverMeal*1).toLocaleString('sv') }</p>
                                        </div>
                                    }

                                    {unitData.TurnoverMealClass &&
                                        <div className="unit-stats__col unit-stats__col--wide"> 
                                            <h2 className="unit-stats__heading">Storleksklass</h2>
                                            <p className="unit-stats__stat-value">{unitData.TurnoverMealClass}</p>
                                        </div>
                                    }

                                    {unitData.TypeName &&
                                        <div className="unit-stats__col unit-stats__col--wide"> 
                                            <h2 className="unit-stats__heading">Enhetstyp</h2>
                                            <p className="unit-stats__stat-value">{unitData.TypeName}</p>
                                        </div>
                                    }

                                    {unitData.LegalName &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Juridiskt namn</h2>
                                            <p className="unit-stats__stat-value">{unitData.LegalName}</p>
                                        </div>
                                    }

                                    {unitData.ChainName &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Kedja</h2>
                                            <p className="unit-stats__stat-value">{unitData.ChainName}</p>
                                        </div>
                                    }

                                    {unitData.MunicipalityName &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Kommun</h2>
                                            <p className="unit-stats__stat-value">{unitData.MunicipalityName}</p>
                                        </div>
                                    }
                                    
                                </div>
                            }
                            
                            {(unitData.TypeGroupName === 'Servicehandel' || !showGraph(unitData.TypeCode, unitData.ChainGroupCode)) &&  
                                <div className="unit-stats__content">
                                    {(unitData.Turnover*1) > 0 &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Årsomsättning livsmedel <span className="unit-stats__heading-unit">(KSEK)</span></h2>
                                            <p className="unit-stats__stat-value">{(unitData.Turnover*1).toLocaleString('sv') }</p>
                                        </div>
                                    }
                                    {unitData.TurnoverClass &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Storleksklass</h2>
                                            <p className="unit-stats__stat-value">{unitData.TurnoverClass}</p>
                                        </div>
                                    }

                                    {(unitData.RetailArea*1) > 0 &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Säljyta</h2>
                                            <p className="unit-stats__stat-value">{unitData.RetailArea.toLocaleString('sv')} m²</p>
                                        </div>
                                    }

                                    {unitData.TypeName &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Enhetstyp</h2>
                                            <p className="unit-stats__stat-value">{unitData.TypeName}</p>
                                        </div>
                                    }
                                    
                                    {unitData.ChainName &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Kedja</h2>
                                            <p className="unit-stats__stat-value">{unitData.ChainName}</p>
                                        </div>
                                    }

                                    {unitData.MunicipalityName &&
                                        <div className="unit-stats__col unit-stats__col--wide">
                                            <h2 className="unit-stats__heading">Kommun</h2>
                                            <p className="unit-stats__stat-value">{unitData.MunicipalityName}</p>
                                        </div>
                                    }
                                </div>
                            }

                            {unitData.TypeGroupName !== 'Servicehandel' && unitData.TypeGroupName !== 'Foodservice' && showGraph(unitData.TypeCode, unitData.ChainGroupCode) &&
                                <div className="unit-stats__content">
                                    <div className="unit-stats__col">
                                        <h2 className="unit-stats__heading">Årsomsättning livsmedel <span className="unit-stats__heading-unit">(KSEK)</span></h2>
                                        <p className="unit-stats__stat-value">{(unitData.Turnover*1).toLocaleString('sv') }</p>
                                        
                                        <h2 className="unit-stats__heading">Säljyta</h2>
                                        <p className="unit-stats__stat-value">{unitData.RetailArea.toLocaleString('sv')} m²</p>

                                        <h2 className="unit-stats__heading">Enhetstyp</h2>
                                        <p className="unit-stats__stat-value">{unitData.TypeName}</p>
                                    </div>
                                    <div className="unit-stats__col">
                                        <h2 className="unit-stats__heading">Storleksklass</h2>
                                        <p className="unit-stats__stat-value">{unitData.TurnoverClass}</p>

                                        <h2 className="unit-stats__heading">Kedja</h2>
                                        <p className="unit-stats__stat-value">{unitData.ChainName}</p>

                                        <h2 className="unit-stats__heading">Kommun</h2>
                                        <p className="unit-stats__stat-value">{unitData.MunicipalityName}</p>
                                    </div>
                                    <div className="unit-stats__col unit-stats__col--last">
                                        {(unitData.TurnoverHistory && unitData.TurnoverHistory.length > 0) &&
                                            <div>
                                                <div className="unit-stats__turnover-screen">
                                                    <LineChart data={unitData.TurnoverHistory} isTurnoverMeal={false} />
                                                </div>
                                                <div className="unit-stats__turnover-print">
                                                    <LineChart data={unitData.TurnoverHistory} isTurnoverMeal={false} />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            
                            {/*<div className="unit-stats__content unit-stats__content unit-stats__content--bottom">
                                <div className="unit-stats__col unit-stats__col--full-width">
                                    <h2 className="unit-stats__heading">KREDITBETYG</h2>
                                    <CreditBar />
                                </div>
                                <div className="unit-stats__col unit-stats__col--small">
                                    <h2 className="unit-stats__heading">UC RISKKLASS</h2>
                                    <p className="unit-stats__stat-value">N/A</p>
                                </div>
                                <div className="unit-stats__col unit-stats__col--small">
                                    <h2 className="unit-stats__heading">UC Riskprognos</h2>
                                    <p className="unit-stats__stat-value">N/A</p>
                                </div>
                                <div className="unit-stats__col unit-stats__col--small unit-stats__col unit-stats__col--small-last">
                                    <h2 className="unit-stats__heading">UC Kreditlimit <span className="unit-stats__heading-unit">(KSEK)</span></h2>
                                    <p className="unit-stats__stat-value">N/A</p>
                                </div>
                            </div>*/}
                        </>
                    }
                </div>
            </div>
        </section>
    );
};

export default UnitStats;